'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _extends() {
  exports._extends_1 = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

exports._extends_1 = _extends;

var _extends$1 = exports._extends_1;

exports["default"] = _extends$1;
